export default function buildItem(item: any, calId: number, canEdit: boolean) {

    let startDate: string;
    let endDate: string;
    if (item.allDay) {
        startDate = item.startDate.substring(0, item.startDate.indexOf('T'));
        endDate = item.endDate.substring(0, item.endDate.indexOf('T'));
    } else {
        startDate = item.startDate.replace('Z', '');
        endDate = item.endDate.replace('Z', '');
    }

    return {
        uid: item.uid,
        allDay: item.allDay,
        endDate: item.endDate.replace('Z', ''),
        startDate: item.startDate.replace('Z', ''),
        type: 'event',
        calId,
        canEdit,
        id: item.uid,
        name: item.summary,
        summary: item.summary,
        location: item.location,
        description: item.description,
        categories: item.categories,
        attendees: item.attendees,
        start: startDate,
        end: endDate,
        status: item.status,
        frequency: item.frequency,
        freqRange: item.freqRange,
        freqUntilDate: item.freqUntilDate,
        freqRecCount: item.freqRecCount,
        freqRecInterval: item.freqRecInterval,
        freqRecByType: item.freqRecByType,
        freqDayPosition: item.freqDayPosition,
        freqDayPositionOnWeek: item.freqDayPositionOnWeek,
        freqEveryWeekDay: item.freqEveryWeekDay,
        color: item?.color ?? '#2BB2AC'
    }
}

/**
 * Format date to string in 'yyyy-mm-dd' format.
 * @param date Date to format.
 */
export function formatDate(date: Date): string {
	const options: Intl.DateTimeFormatOptions = {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit'
	};
	return date.toLocaleDateString('en-CA', options);
}
